// Blocks
import { initStaticVueApp } from 'dacl.cms.vue.components';

import 'dacl.cms.vue.components/dist/style.css';
import 'dws-dx/dist/style.css';

initStaticVueApp();
